import appManage from "../../reducers/app-manager";
import { notify } from "../../components/blocks/Notify";
import { setLog } from "../../helpers/functions";
import { getIpcRenderer } from '../../reducers/ipc-loader.js';
const RFID_FAIL = "RFID_FAIL";
class moduleRfid {
    /**
     *    let option - массив имеющий следующие параметры
     *    baudRate: 9600,
     *    port: 'COM5', - port
     *
     *    callbackResult - функция куда будет возвращен результат, с аргументом типа String f(String)
     *
     *    после создания объекта, следует использовать команду start()
     */
    constructor(option) {
        this.baudRate = (option.baudRate === undefined) ? 9600 : option.baudRate;
        this.path = (option.port === undefined) ? 'COM4' : option.port;
        this.isHid = option.isHid ? true : false;
        this.isPort = false;
        this.isOpen = false;

       
        try {
            if (!this.isHid) {
                    getIpcRenderer().then((ipcRenderer)=>{
                        if(ipcRenderer){
                            ipcRenderer.invoke('init-serial-port', {path:this.path,baudRate: this.baudRate, autoOpen: true,parserConfig:{ type:'regex',regexPattern:"[\\r\\n]+"}}).then(res=>{                               
                                if(!res.success){
                                    appManage.isRfidWork(false);                         
                                }                    
                            })    
                            ipcRenderer.invoke('open-serial-port',{path:this.path}).then(res=>{               
                                if(res.success){
                                    this.isOpen = true;
                                    this.checkStatus().then(res => {
                                        this.isPort = res;                       
                                        appManage.isRfidWork(res);
                                    });
                                }else{
                                    appManage.isRfidWork(false);
                                }
                            });             
                        }    
                    });
            } else {
                appManage.isRfidWork(true);
            }
        } catch (e) {
            e.typeError = RFID_FAIL;
            let info = "Ошибка в moduleRfid";
            setLog(info, e);
            notify(info, 'error');
            appManage.isRfidWork(false);
        }
    }

    /**
     * Начать выполнение
     * @returns {Promise.Promise}
     */
    start() {
        return new Promise((resolve, reject) => {
            try {
                getIpcRenderer().then((ipcRenderer)=>{
                    if(ipcRenderer){
                        ipcRenderer.send('start-serial-listening',{path:this.path,useParser:true});
                        ipcRenderer.on('serial-data', (event, data) => {
                            if(data.path === this.path)
                            {
                                if(data.data !== 'Err5: Syntax'){
                                    resolve(data.data);
                                }

                            }
                        });
                    }
                });
               
            } catch (e) {
                reject(e);
            }
        })
    }

    close() {
		return  new Promise((resolve, reject) => {
			if (this.isOpen === true) {
                getIpcRenderer().then((ipcRenderer)=>{
                    if(ipcRenderer){
                        ipcRenderer.invoke('close-serial-port',this.path);                               				
                    }
                });
			}
		});
	}

    reset() {
		return  new Promise((resolve, reject) => {
			if (this.isOpen === true) {
                getIpcRenderer().then((ipcRenderer)=>{
                    if(ipcRenderer){
                        ipcRenderer.invoke('write-serial-data-drain',{path:this.path,data:'$RESET\r\n',encoding:'ascii'}).than(res=>{
                            if(!res.success)
                            {
                                reject(res.error);
                            }
                        });				
                    }
                });
			}
		});
	}

    checkStatus() {
		let isData = [];
		return  new Promise((resolve, reject) => {
            let checkPortStatus = false;
			try {
                getIpcRenderer().then((ipcRenderer)=>{
                    if(ipcRenderer){
                        ipcRenderer.invoke('write-serial-data-drain',{path:this.path,data:'00CCDD\r\n',encoding:'ascii'}).then(res=>{
                        
                        });
                        
                        ipcRenderer.invoke('read-serial-data',{path:this.path,useParser:true,timeout:5000}).then(res => {
                            if(res.success)
                            {
                                isData.push(res.data);
                                if (isData.length > 0) resolve(true);
                            }else{
                                resolve(false);
                            }
                        });
            
                        
                        if (this.isOpen === false) {

                            ipcRenderer.invoke('open-serial-port', {path:this.path,baudRate: this.baudRate, autoOpen: false,parserConfig:{ type:'regex',regexPattern:"[\\r\\n]+"}}).then(res=>{  
                                if(!resOpened.success)
                                {
                                    if (resOpened.error) {
                                        error.typeError = RFID_FAIL;
                                        error.message = resOpened.error;
                                        setLog('Ошибка порта при подключении к RFID', error);
                                        resolve(false);
                                    }
                                }
                            });                    
                        }
                    }
                });

                setTimeout(() => {
                    if (isData.length === 0) {
                        notify('Ошибка подключения RFID', 'error');
                        resolve(false);
                    }
                }, 2000)
            } catch (e) {
                resolve(false);
            }
		})
	}
}

export default moduleRfid;